import { useAuth0, withAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { API_URL } from "../../ConstVariable";
import { CallTakenByOperatorFunc, SetError } from "../../redux-store/actions";
import ChatDetails from "./ChatDetails";
import "./Conversation.css";
import ReferralView from "./ReferralView";
import { CheckBox } from "devextreme-react";

const ConversationWidget = (props) => {
    console.log("props:", props)
    const { getAccessTokenSilently, user,logout } = useAuth0();
    let user_profile = user?.oi_profile?.toLowerCase();
    // const[openLogDialog, setOpenLogDialog] = useState("")

    const LogoutFunc = () => {
        logout({ returnTo: window.location.origin });
    };
    const [showReferral, setShowReferral] = useState(false);
    const [showAppliedRules, setShowAppliedRules] = useState(false);
    const [appliedRulesLoader, setAppliedRulesLoader] = useState(false);
    const [appliedRulesData, setAppliedRulesData] = useState([]);
    const [conversationData, setConversationData] = useState([]);
    const [convesationLoader, setConvesationLoader] = useState(false);

    // NOTE:- callerIdCpy, convesationCpy, these state stores the callerID and conversation_id when we click on copy icon
    const [callerIdCpy, setCallerIdCpy] = useState(false);
    const [convesationCpy, setConvesationCpy] = useState(false);

    // NOTE:- using useSelector , we are getting the redux store data
    // This hook gives the whole state of redux store
    const state = useSelector((state) => state);
    const [showDialogCodes, setShowDialogCodes] = useState(false);
    let MobileNumber = state.Mobile_Number;
    let selectedConversationId = state.SelectedConversationId;
    let isReferralFormPresent = state.ReferralFormPresent;
    let Caller_Id = state.Caller_id;
    let CenterName = state.Center;
    let CenterPrefix = state.CenterPrefix;

    let conversation_logs = state.ConversationLogs;
    let centerIdOfSelectedCall = state.center_id
    console.log("🚀 ~ file: ConversationWidget.js:38 ~ centerIdOfSelectedCall", centerIdOfSelectedCall, MobileNumber, Caller_Id)

    // let OperatorName =
    //   props.operatorName != null && props.operatorName.capitalize();

    // NOTE:- FetchConversationData function fetch the conversation for selected call card and stores this data to local state of ConversationWidget component

    const FetchConversationData = async () => {
        setShowReferral(false);
        // alert("Hello Api call");
        // console.log("Call_Source", props.CallSource);

        // NOTE:- To check if Order is Manual Order or Not . if Order is manual Order than do not show the "No Data found for conversation"
        // not send the request to search the conversation details

        if (state.CallSource === "DIRECT_CALL") {
            // alert("Entered in Manual");
            return;
        }

        // NOTE:- Here , before fetching the data , we are making null to conversationData
        setConversationData([]);
        const token = await getAccessTokenSilently();
        if (selectedConversationId) {
            // alert("Feching Conversation Data");

            // alert("Entered to the Conversation API");
            fetch(API_URL + "/oi/api/v1/conversation/" + selectedConversationId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                credentials: "include"
            })
                .then((response) =>{ 
                  if(response?.status==401 || response?.status==403){
                      console.log("Session-Manger-Session-Timeout");
                      LogoutFunc()
                    }
                    return response.json()
                })
                .then((data) => {
                    // console.log("Fetched Conversation Data", data);
                    setConversationData(data);
                    setConvesationLoader(false);

                    if (data.length === 0) {
                        props.SetErrorForDisplay({
                            severity: "warning",
                            message: "No Data found for convesation",
                        });
                    }

                    return;
                })
                .catch((err) => {
                    props.SetErrorForDisplay({
                        severity: "warning",
                        message: err.message,
                    });
                    return;
                });
        }
    };

    const FetchAppliedRulesData = async () => {
        setShowReferral(false);
        setAppliedRulesLoader(true);

        if (state.CallSource === "DIRECT_CALL") {
            // alert("Entered in Manual");
            return;
        }

        setAppliedRulesData([]);
        const token = await getAccessTokenSilently();
        if (selectedConversationId) {
            // alert("Feching Applied Rules Data");

            await fetch(API_URL + "/oi/api/v1/get-conversation-applied-rules/" + selectedConversationId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                credentials: "include"
            })
                .then((response) => response.json())
                .then((data) => {
                    // console.log("Ser Applied Rules Data", data);
                    setAppliedRulesData(data?.data);

                    if (data.length === 0) {
                        props.SetErrorForDisplay({
                            severity: "warning",
                            message: "No Applied Rules Data found for convesation",
                        });
                    }

                    return;
                })
                .catch((err) => {
                    props.SetErrorForDisplay({
                        severity: "warning",
                        message: err.message,
                    });
                    setAppliedRulesData([]);
                    return;
                });
        }
        setAppliedRulesLoader(false);
    };
    // NOTE:- This useEffect  hook runs every time when SelectedConversationId changes
    //And runs the all function inside of this Hook

    useEffect(() => {
        if (selectedConversationId != null) {
            FetchConversationData();
            setCallerIdCpy(false);
            FetchAppliedRulesData()
            setConvesationCpy(false);
        }
    }, [selectedConversationId]);

    //NOTE:- Removing the conversation Data initially

    // NOTE:- This useEffect hook runs when conversation_logs data changes
    useEffect(() => {
        setConversationData(conversation_logs);
    }, [conversation_logs]);

    const ShowCallerId = ({ Mobile_Number }) => {
        if (selectedConversationId) {

            if ((state.CallSource === "WEBBOT" || state.CallSource === "CHAT" || state.CallSource === "CHATTY")) {
                if (Mobile_Number) {
                    return Mobile_Number
                } else if (Caller_Id) {
                    return Caller_Id
                } else {
                    return ""
                }

            } else {
                if (Caller_Id) {
                    return Caller_Id
                } else {
                    return ""
                }

            }
        }
        else {
            return ""
        }


    };

    let CallerIdToCopy = () => {
        if (selectedConversationId) {

            if ((state.CallSource === "WEBBOT" || state.CallSource === "CHAT" || state.CallSource === "CHATTY")) {
                if (MobileNumber) {
                    return MobileNumber
                } else if (Caller_Id) {
                    return Caller_Id
                } else {
                    return ""
                }

            } else {
                if (Caller_Id) {
                    return Caller_Id
                } else {
                    return ""
                }

            }
        }
        // if (MobileNumber != null && selectedConversationId != null) {
        //   return MobileNumber;
        // } else if (MobileNumber == null && selectedConversationId != null) {
        //   return Caller_Id;
        // } else if (
        //   MobileNumber != null &&
        //   Caller_Id != MobileNumber &&
        //   selectedConversationId != null
        // ) {
        //   return MobileNumber;
        // } else {
        //   return "";
        // }
    };

    const showConvesationLoadingAnimation = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img
                    id="convloader"
                    width="100%"
                    height="100%"
                    src="/assets/images/messenger-icon.gif"
                />
            </div>
        );
    };

    // NOTE :- This callTakenHandler function was written to show the check box click or not
    // clicked checked box represents that this call has beent taken by an operator
    const callTakenHandler = (event) => {
        // console.log("CHECK box clicked", event.target.checked);
        props.clientSideMessage({
            conversation_id: props.SelectedConversationId,
            operator_id: props.operatorEmail,
            event: "CURRENT_OPERATOR",
        });
        props.callTakenByOperatorFunction(event.target.checked);
    };


    return (
        <div
            style={{
                // height: "90vh",
                height:user_profile == "demo" ? "100vh":"100%",
                width:user_profile == "demo"? "60%":"100%",
                marginRight: "0px",
                marginLeft: user_profile == "demo" ? "20%" : "0",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div style={{ display: user_profile=="demo"?"none":"flex", justifyContent: "space-between", borderBottom: "1px solid gray" }}>

                <div
                    className="tab"
                    style={{
                        // width: "100%",
                        backgroundColor: "#F1F1F1",
                        minHeight: "30px",
                    }}
                >
                    <button
                        className={
                            !showReferral && !showAppliedRules
                                ? "tablinks active"
                                : "tablinks"
                        }
                        onClick={() => {
                            setShowReferral(false);
                            setShowAppliedRules(false)
                        }}
                    >
                        Transcript
                    </button>
                    {user?.oi_profile?.toLowerCase() !== "customer" && <button
                        className={
                            showAppliedRules
                                ? "tablinks active"
                                : "tablinks"
                        }
                        style={{
                            marginLeft: "2px",
                            marginRight: "2px",
                        }}
                        onClick={() => {
                            setShowReferral(false);
                            setShowAppliedRules(true);
                            FetchAppliedRulesData()
                        }}
                    >
                        Rules applied
                    </button>}
                    {user?.oi_profile?.toLowerCase() !== "customer" && (isReferralFormPresent === "Available" ||
                        isReferralFormPresent === "Referral_re_request" ||
                        isReferralFormPresent === "Processed") && (
                            <button
                                className={showReferral ? "tablinks active" : "tablinks"}
                                onClick={() => {
                                    setShowReferral(true);
                                    setShowAppliedRules(false);
                                }}
                            >
                                Referral
                            </button>
                        )}

                </div>
                {user?.oi_profile?.toLowerCase() !== "customer" &&
                    <div>
                        <CheckBox onValueChanged={(e) => { console.log(e); setShowDialogCodes(e.value) }} text="Show dialog codes"></CheckBox> |
                        {
                            user.profile && user.profile.toLowerCase() === "oi-admin" && selectedConversationId && (
                                <Link
                                    to={{ pathname: `/logs/${selectedConversationId}` }}
                                    target="_blank"
                                >
                                    Logs
                                </Link>
                            )
                        }
                        |
                        {
                            selectedConversationId && (
                                <Link to={{ pathname: `/health/bp-broker/${CenterPrefix}` }} target="_blank">Broker health</Link>
                            )
                        }
                    </div>
                }
            </div>

            {conversationData.length == 0 &&
                selectedConversationId !== null &&
                !["DIRECT_CALL"].includes(props.CallSource) ? (
                showConvesationLoadingAnimation()
            ) : (
                <div
                    id="conversation-data"
                    style={{
                        flex: "1",
                        overflowY: "hidden",
                        background: "white",
                        display:
                            showReferral === false && showAppliedRules == false
                                ? "block"
                                : "none",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <p style={{ display:user_profile=="demo"?"none": "flex" }}>
                            <p id="caller_id" style={{ marginRight: "5px" }}>
                                <ShowCallerId Mobile_Number={state.Mobile_Number} />
                            </p>
                            <br />
                            <CopyToClipboard
                                text={CallerIdToCopy()}
                                onCopy={() => setCallerIdCpy(true)}
                            >
                                <p
                                    style={{
                                        cursor: "copy",
                                        fontSize: "10px",
                                        display: selectedConversationId === null ? "none" : " ",
                                        display: "flex",
                                    }}
                                >
                                    <img
                                        src="https://img.icons8.com/fluent-systems-regular/24/000000/copy.png"
                                        style={{
                                            display: selectedConversationId === null ? "none" : " ",
                                        }}
                                    />
                                    <p style={{ display: callerIdCpy === true ? "" : "none" }}>
                                        copied !
                                    </p>
                                </p>
                            </CopyToClipboard>
                            <br />

                        </p>
                        <p>
                            {CenterPrefix}
                            {CenterPrefix != null && "-"}
                            {CenterName}
                        </p>
                        <p style={{ display: "flex" ,marginTop:user_profile=="demo" && "10px"}}>
                            <p id="conversation_id" style={{ marginRight: "5px" }}>
                                {selectedConversationId} {state.client_ip ? <span style={{ fontSize: '12px' }}>({state.client_ip})</span> : ""}
                            </p>
                            <CopyToClipboard
                                text={selectedConversationId}
                                onCopy={() => setConvesationCpy(true)}
                            >
                                <p
                                    style={{
                                        cursor: "copy",
                                        fontSize: "10px",
                                        display: selectedConversationId ? "" : "none",
                                        display: "flex",
                                    }}
                                >
                                    <img
                                        src="https://img.icons8.com/fluent-systems-regular/24/000000/copy.png"
                                        style={{
                                            display: selectedConversationId === null ? "none" : " ",
                                        }}
                                    />
                                    <p style={{ display: convesationCpy === true ? "" : "none" }}>
                                        copied !
                                    </p>
                                </p>
                            </CopyToClipboard>
                        </p>
                    </div>
                    {!["DIRECT_CALL"].includes(state.CallSource) && (
                        <ChatDetails conversationData={conversationData} setConversationData={setConversationData} showDialogCodes={showDialogCodes} />
                    )}
                </div>
            )}

            <div
                id="referral-form-data"
                style={{
                    flex: "1",
                    background: "white",
                    display: showReferral === true ? "block" : "none",
                }}
            >
                {showReferral && (
                    <ReferralView conversation_id={selectedConversationId}></ReferralView>
                )}
                {/* Referral form shown here... */}
            </div>
            <div
                id="referral-form-data"
                style={{
                    flex: "1",
                    background: "white",
                    display: showAppliedRules === true ? "block" : "none",
                }}
            >
                {showAppliedRules && conversationData.length !== 0 && (
                    <div style={{ padding: "10px" }}>
                        {/* Scrollable wrapper for both directions */}
                        <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "600px" }}>
                            <table
                                border="1"
                                cellPadding="8"
                                cellSpacing="0"
                                style={{ width: "100%", minWidth: "800px", borderCollapse: "collapse" }}
                            >
                                <thead>
                                    <tr>
                                        <th>Rule ID</th>
                                        <th>Rule Type</th>
                                        <th>Center ID</th>
                                        <th>Rule Name</th>
                                        <th>Rule Data</th>
                                        <th>Match Score</th>
                                    </tr>
                                </thead>
                                <tbody style={{ display: appliedRulesLoader ? "none" : "table-row-group" }}>
                                    {appliedRulesData.map((el, index) => (
                                        <tr key={index}>
                                            <td>{el?.rule_id}</td>
                                            <td>{el?.rule_type}</td>
                                            <td>{el?.rule_center_id}</td>
                                            <td>{el?.rule_name}</td>
                                            <td>{el?.rule_data}</td>
                                            <td>{el?.match_score}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Loader and No Data messages */}
                        {appliedRulesLoader && (
                            <div style={{ color: "red", fontWeight: "bold", padding: "10px" }}>
                                Loading...
                            </div>
                        )}
                        {appliedRulesData?.length === 0 && !appliedRulesLoader && (
                            <div style={{ color: "red", fontWeight: "bold", padding: "10px" }}>
                                No Rules Data present
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

// NOTE:- this method returns the state of redux store which are written into this method
const mapStateToProps = (state) => {
    console.log("state:", state)
    return {
        errorForDisplay: state.Error,
        operatorName: state.operatorName,
        CallTakenByOperator: state.CallTakenByOperator,
        SelectedConversationId: state.SelectedConversationId,
        operatorEmail: state.operatorEmail,
        //HERE we are extracting the Call Source field from the redux store
        CallSource: state.CallSource,
        CenterPrefix: state.CenterPrefix
    };
};

//  NOTE:- this mapDispatchToProps method  returns the action to dispatch to redux store

const mapDispatchToProps = (dispatch) => {
    return {
        SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
        callTakenByOperatorFunction: (val) =>
            dispatch(CallTakenByOperatorFunc(val)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth0(ConversationWidget));
